import React, { useContext } from 'react';
import styled from 'styled-components';
import { MapContext } from 'react-mapbox-gl';

import { HEATMAP_LAYERS } from './constants';
import { LayerButton } from './components/LayerButton';
import { LayersControlDemo } from './components/LayersControlDemo';

interface LayersControlProps {
  isMobile: boolean;
}

/**
 * Контролл позволяет отобразить цветовые области на карте: бары, музеи и шоппинг
 */
export const LayersControl = (
  props: LayersControlProps,
): JSX.Element | null => {
  const { isMobile } = props;
  const map = useContext(MapContext);

  if (!map) return null;

  return (
    <Container
      $isMobile={isMobile}
      onMouseEnter={() => map.doubleClickZoom.disable()}
      onMouseLeave={() => map.doubleClickZoom.enable()}
    >
      <LayersControlDemo />

      {HEATMAP_LAYERS.map((layer) => (
        <LayerButton map={map} key={layer.id} {...layer} />
      ))}
    </Container>
  );
};

const Container = styled.div<{ $isMobile: boolean }>`
  position: absolute;
  z-index: 15; // override HotelMapMarker point
  top: 10px;
  left: 10px;
  top: 135px;
  width: 46px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      top: 20%;
      transform: translateY(-50%);
  `}
`;
